var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"room-wrapper"}},[_c('h1',{staticClass:"title is-1"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c(_vm.roomView,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }